import isWithinRange from "date-fns/is_within_range";
const isWithinAnInterval = (day, intervals) => intervals.some(interval => isWithinRange(day, interval.start, interval.end));
export default isWithinAnInterval;
//# sourceMappingURL=isWithinAnInterval.js.map